import React from "react";
import { Col } from "react-bootstrap";
import { FieldGroup } from "../Groups/FieldGroup";
import { RadioField } from "../Fields/RadioField";
import { pickOne } from "../Validation";

export const ContentLanguageForm = ( props ) => {
    return <>
        <Col md={ 12 }>
            <FieldGroup
                groupName="Content Language Option"
                groupId="Content Language"
                groupLabel="What do you need?"
                validator={ pickOne }
            >
                {/* OPTION existing */ }
                <RadioField
                    fieldId="Content Language Option"
                    fieldLabel={ "I need an existing English-language " + props.elementType }
                    fieldValue="Existing"
                />

                {/* OPTION translation (opens translation form) */ }
                <RadioField
                    fieldId="Content Language Option"
                    fieldLabel={ "I need an existing English-language " + props.elementType + " in my local language." }
                    fieldValue="Translation"
                />

                {/* OPTION special (opens special form) */ }
                <RadioField
                    fieldId="Content Language Option"
                    fieldLabel={ "I need a new " + props.elementType + " in my local language." }
                    fieldValue="Special"
                />
            </FieldGroup>
        </Col>
    </>;
}